module.exports = __webpack_public_path__ + "img/icon-roxot.b737d1e7.jpeg";